import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Button, Row, Col } from 'reactstrap';
import { faCamera, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Componentes
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ExecucaoFiscalizacaoStepper from './components/ExecucaoFiscalizacaoStepper';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField';

//Context
import { useAuth } from '../../../context/auth';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Api
import solicitacaoFiscalizacao_api from '../../../api/solicitacaoFiscalizacao_api';
import solicitacaoFiscalizacaoFinalizada_api from '../../../api/solicitacaoFiscalizacaoFinalizada_api';

function initialStateFinalizacaoSemFiscalizacao(idSolicitacao = "") {
    return {
        justificativa: "",
        arquivo: "",
        dataHora: "",
        solicitacaoFiscalizacao_Id: idSolicitacao,
    }
}
function ExecucaoDeFiscalizacao() {
    const { setLoading } = useAuth();

    //Referencia para o campo de arquivo da finalização
    const refFileFinalizacao = useRef();

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => {
        setVisibleModal(!visibleModal)
        setErrors({});
    };

    //Estado de controle da lista de solicitações
    const [listaSolicitacoes, setListaSolicitacoes] = useState([]);

    //Estado de controle do id da solicitação a ser fiscalizada
    const [solicitacaoFiscalizacao, setSolicitacaoFiscalizacao] = useState(null);

    //Estado que guarda a ação que será executada
    const [acao, setAcao] = useState("Fiscalizar");

    //Estado de controle da fiscalização avulsa
    const [fiscalizacaoAvulsa, setFiscalizacaoAvulsa] = useState(false);

    //Estado que guarda o objeto de envio dos dados da finalização
    const [finalizacao, setFinalizacao] = useState(initialStateFinalizacaoSemFiscalizacao());

    //Estado de controle de errors na finalizacao
    const [errors, setErrors] = useState({});

    //campos obrigatorios da finalizacao
    const camposFinalizacao = [
        objCampo({ name: "justificativa", required: "true" })
    ]

    //onChange dos campos da finalizacao  
    const onChange = (e) => {
        const { name, value } = e.target;
        setFinalizacao({
            ...finalizacao,
            [name]: value
        });
    }

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Tipo de Fiscalização", objectValue: "tipoFiscalizacao_Descricao", align: "left" },
        { value: "Data do Flagrante", objectValue: "dataFlagrandeFormatada", align: "left" },
        { value: "Nome Denunciante", objectValue: "contatoDenuncia_Nome", align: "left" },
        { value: "Endereço", objectValue: "enderecoCompleto", align: "left" },
        { value: "Origem", objectValue: "origem", align: "left" },
        { value: "Prazo de execução", objectValue: "dataLimiteExecucaoFormatada", align: "left" },
        { value: "Endereço", objectValue: "enderecoCompleto", align: "left" },
        { value: "Subprefeitura", objectValue: "regional", align: "left" }
    ];

    //Função que carrega a lista de solicitações pendentes
    const loadSolicitacoes = () => {
        setLoading(true);
        solicitacaoFiscalizacao_api.getListPendentes().then(response => {
            response.data = response.data.map(value => {
                value.dataFlagrandeFormatada = !!value.dataFlagrande ? moment(value.dataFlagrande).format("DD/MM/YYYY HH:mm:ss") : "Sem data";
                value.dataLimiteExecucaoFormatada = value.dataLimiteExecucao ? moment(value.dataLimiteExecucao).format("DD/MM/YYYY") : "";
                return value;
            })
            setListaSolicitacoes(response.data);
        }).catch(ex => showMessage('Aviso!', ex.message, "error", null))
            .finally(f => setLoading(false));
    };

    useEffect(() => {
        loadSolicitacoes();
    }, []);

    
    //Função que envia os dados da solicitação para a tela de fiscalização
    const realizarFiscalizacao = (solicitacao) => {
        setSolicitacaoFiscalizacao(solicitacao);
        setAcao("Fiscalizar");
    }

    //Função que salva os dados da solicitação para a finalização
    const realizarFinalizacao = (solicitacao) => {
        setFinalizacao(initialStateFinalizacaoSemFiscalizacao(solicitacao.id));
        setSolicitacaoFiscalizacao(solicitacao);
        setAcao("Finalizar");
        toggleModal();
    }

    //Função responsavel por pelo clique no botão de tirar foto
    const onClickSalvarFoto = () => {
        refFileFinalizacao.current.click();
    };

    //Função de onChange do arquivo
    const handleFileChange = (e) => {
        const FR = new FileReader();
        FR.addEventListener("load", function (evt) {
            const extensao = evt.target.result.split("/")[1].split(";")[0];
            if (extensao != "png" && extensao != "jpg" && extensao != "jpeg") {
                showMessage("Aviso!", "Apenas arquivos com extensão do tipo imagem são aceitos", "warning", null);
                return;
            }
            const _finalizacao = {
                ...finalizacao,
                arquivo: evt.target.result.split("base64,")[1],
            };
            setFinalizacao(_finalizacao);
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    };

    //Função que envia os dados da finalização para a api
    const onSubmitFinalizacao = () => {
        const _errors = validarCampos(finalizacao, camposFinalizacao);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _sincronizacao = {
            ...finalizacao
        }
        _sincronizacao.dataHora = moment().format();
        setLoading(true);
        solicitacaoFiscalizacaoFinalizada_api.post(_sincronizacao).then(async response => {
            showMessage("Sucesso!", "Solicitação finalizada com sucesso!", "success", null);
            loadSolicitacoes();
            toggleModal();
        }).catch(e => {
            showMessage("Aviso", e.message, "error", true);
        })
            .finally(f => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.confirmar(realizarFinalizacao), actionsTable.dinamico(faFileSignature, realizarFiscalizacao)];

    const handleVoltar = () => {
        setSolicitacaoFiscalizacao(null);
        setFiscalizacaoAvulsa(false);
        loadSolicitacoes();
    }

    if ((solicitacaoFiscalizacao && acao == "Fiscalizar") || fiscalizacaoAvulsa) {
        return <ExecucaoFiscalizacaoStepper
            solicitacaoFiscalizacao={solicitacaoFiscalizacao}
            handleVoltar={handleVoltar}
            avulso={fiscalizacaoAvulsa}
        />
    }

    return <>
        <ModalCustomized title={"Finalizar solicitação sem fiscalização"} isOpen={visibleModal} toggle={toggleModal} btnClose>
            <Row>
                <Col md="12">
                    <TextField
                        name="justificativa"
                        label={"Observações"}
                        value={finalizacao.justificativa}
                        onChange={onChange}
                        type={'textarea'}
                        invalid={!!errors.justificativa}
                    />
                </Col>
                <Col md="12">
                    <Button onClick={onClickSalvarFoto} className='w-100' color={finalizacao.arquivo ? "warning text-white" : "primary"}><FontAwesomeIcon icon={faCamera} /> Enviar Imagem</Button>
                </Col>
                <Col md="12">
                    <Button className='w-100 mt-3' color={"success"} onClick={onSubmitFinalizacao}>Salvar finalização</Button>
                </Col>
                <input
                    type="file"
                    ref={refFileFinalizacao}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                />
            </Row>
        </ModalCustomized>
        <div className='d-flex align-items-center justify-content-between mb-3'>
            <h4 className='text-secondary m-0'>Execução de fiscalização</h4>
            <Button color='success' onClick={() => setFiscalizacaoAvulsa(true)}>Fiscalização avulsa</Button>
        </div>
        <TabelaListagem
            actions={actions}
            title={"Lista de fiscalizações"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listaSolicitacoes}
        />
    </>;
}

export default ExecucaoDeFiscalizacao;